import React, { useState, useEffect } from "react";
import {
  IconButton,
  Tooltip,
  Button,
  Typography,
  Box,
  Fade,
  Paper,
  CircularProgress,
} from "@mui/material";
import { 
  Update as UpdateIcon, 
  Refresh as RefreshIcon,
  Info as InfoIcon,
  Close as CloseIcon 
} from "@mui/icons-material";
import api from "../../services/api";

const packageVersion = require("../../../package.json").version;


const VersionControl = () => {
  return null;
};

export default VersionControl;